import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";

interface ChoiceStatusBarProps {
  selected: boolean;
  hintText?: string;
}

export function ChoiceStatusBar({
  selected,
  hintText = "Choose one option to continue",
}: ChoiceStatusBarProps) {
  return (
    <div className="flex items-center justify-between py-2 text-xs">
      <motion.span
        animate={{ opacity: selected ? 0.3 : 1 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
        className="italic"
        style={{ color: "#8890b8" }}
      >
        {hintText}
      </motion.span>
      <AnimatePresence>
        {selected && (
          <motion.span
            initial={{ x: -8, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -8, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="flex items-center gap-1.5 font-medium text-[#10b981]"
          >
            <Check className="h-3.5 w-3.5" />
            Ready to submit
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
}